// extracted by mini-css-extract-plugin
module.exports = {"modal":"style__modal___1WhYc"};